import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ImportResultDto } from '../../../models/employeeHub';
import { employeeImportService } from '../services/employeeImportService';
import { importHistoryQueryKey } from './useImportHistory';

interface ImportEmployeesArgs {
    file: File;
    autoCreateDictionaries: boolean;
    importDate?: string;
}

export const useImportEmployees = () => {
    const queryClient = useQueryClient();

    return useMutation<ImportResultDto, Error, ImportEmployeesArgs>({
        mutationFn: ({ file, autoCreateDictionaries, importDate }: ImportEmployeesArgs) =>
            employeeImportService.importEmployees(file, autoCreateDictionaries, importDate),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: importHistoryQueryKey });
        },
    });
};
